import React from 'react'
import propTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { useWizardFieldStyles } from '../wizardFieldStyles'

const LinkUrlInput = ({ value, error, onChange }) => {
	const classes = useWizardFieldStyles()
	return (
		<TextField
			className={classes.textField}
			fullWidth
			variant='outlined'
			margin='dense'
			label='Link URL'
			placeholder='https://...'
			value={value}
			onChange={(e) => onChange(e.target.value)}
			error={Boolean(error)}
			helperText={error || ''}
		/>
	)
}

LinkUrlInput.propTypes = {
	value: propTypes.string.isRequired,
	error: propTypes.string,
	onChange: propTypes.func.isRequired
}

LinkUrlInput.defaultProps = {
	error: null
}

export default LinkUrlInput
